/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type QrCodeCell_qrCode$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type QrCodeList_lists$ref: FragmentReference;
declare export opaque type QrCodeList_lists$fragmentType: QrCodeList_lists$ref;
export type QrCodeList_lists = {|
  +id: string,
  +qrCodes: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: QrCodeCell_qrCode$ref,
      |}
    |}>
  |},
  +$refType: QrCodeList_lists$ref,
|};
export type QrCodeList_lists$data = QrCodeList_lists;
export type QrCodeList_lists$key = {
  +$data?: QrCodeList_lists$data,
  +$fragmentRefs: QrCodeList_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "qrCodes"
        ]
      }
    ]
  },
  "name": "QrCodeList_lists",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "qrCodes",
      "args": null,
      "concreteType": "QrCodeConnection",
      "kind": "LinkedField",
      "name": "__QrCodeList_qrCodes_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QrCodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QrCode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "QrCodeCell_qrCode"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Lists"
};
})();
// prettier-ignore
(node/*: any*/).hash = '75895cc6b5b02ea3df933714cbbec1f2';

module.exports = node;
